import Currencies from "./currencies";

export default Currencies;
